(() => {
  const script = document.currentScript;
  const api = (script && script.dataset.api) || "";
  if (!api) return;

  const style = document.createElement("style");
  style.textContent = `
    .rp-toast{position:fixed;left:16px;bottom:16px;z-index:2147483000;width:min(300px,calc(100vw - 32px));display:flex;gap:12px;align-items:center;padding:12px 10px 12px 12px;background:#fff;color:#161616;border:1px solid #e6e8ec;border-radius:6px;box-shadow:0 16px 40px rgba(27,36,48,.14);font-family:"Segoe UI",system-ui,sans-serif;font-size:14px}
    .rp-toast[hidden]{display:none}
    .rp-toast.is-visible{animation:rp-pop 4s ease forwards}
    .rp-toast img{width:64px;height:64px;object-fit:cover;border-radius:4px;background:#f3f4f6;flex:none}
    .rp-copy{min-width:0;flex:1}
    .rp-kicker,.rp-title,.rp-meta{margin:0}
    .rp-kicker{font-size:11px;font-weight:400;letter-spacing:.12em;text-transform:uppercase;color:#1b2430}
    .rp-title{margin-top:4px;font-size:15px;font-weight:400;line-height:1.3}
    .rp-meta{display:flex;align-items:center;gap:8px;margin-top:5px;color:#6b7280;font-size:13px}
    .rp-verified{display:inline-flex;align-items:center;gap:4px;color:#0f766e;font-weight:400;font-size:11px;letter-spacing:.04em;text-transform:uppercase}
    .rp-close{border:0;background:transparent;color:#78716c;font-size:18px;line-height:1;cursor:pointer;align-self:flex-start}
    @keyframes rp-pop{0%{opacity:0;transform:translateY(1rem)}10%{opacity:1;transform:translateY(0)}80%{opacity:1;transform:translateY(0)}100%{opacity:0;transform:translateY(.4rem)}}
  `;
  document.head.appendChild(style);

  const toast = document.createElement("aside");
  toast.className = "rp-toast";
  toast.hidden = true;
  toast.innerHTML = `
    <img alt="" hidden>
    <div class="rp-copy">
      <p class="rp-kicker">Recently purchased</p>
      <p class="rp-title"></p>
      <p class="rp-meta"></p>
    </div>
    <button class="rp-close" type="button" aria-label="Dismiss">×</button>
  `;
  document.body.appendChild(toast);

  const image = toast.querySelector("img");
  const title = toast.querySelector(".rp-title");
  const meta = toast.querySelector(".rp-meta");
  const DISMISS_KEY = "rp-dismissed-until";
  const VISIBLE_MS = 4000;
  const GAP_MS = 4000;
  let orders = [];
  let index = 0;
  let timer = 0;
  let stopped = false;

  function text(value) {
    return String(value).replace(/[&<>"]/g, (char) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[char]));
  }

  function loadImage(src) {
    if (!src) return Promise.resolve(false);
    return new Promise((resolve) => {
      const preload = new Image();
      preload.onload = () => resolve(true);
      preload.onerror = () => resolve(false);
      preload.src = src;
    });
  }

  async function show(order) {
    const ready = await loadImage(order.image);
    if (stopped) return;
    const city = text(order.city || "Australia");
    title.textContent = `${order.buyer} bought ${order.product}`;
    meta.innerHTML = `<span>${city}</span><span class="rp-verified">Verified</span>`;
    if (ready) {
      image.src = order.image;
      image.hidden = false;
    } else {
      image.hidden = true;
    }
    toast.hidden = false;
    toast.classList.remove("is-visible");
    void toast.offsetWidth;
    toast.classList.add("is-visible");
  }

  function queueNext() {
    clearTimeout(timer);
    timer = setTimeout(async () => {
      if (stopped || !orders.length) return;
      await show(orders[index % orders.length]);
      index += 1;
      queueNext();
    }, VISIBLE_MS + GAP_MS);
  }

  toast.querySelector(".rp-close").addEventListener("click", () => {
    stopped = true;
    clearTimeout(timer);
    toast.hidden = true;
    localStorage.setItem(DISMISS_KEY, String(Date.now() + 30 * 60 * 1000));
  });

  if (Number(localStorage.getItem(DISMISS_KEY) || 0) > Date.now()) return;

  fetch(`${api.replace(/\/$/, "")}/api/recent`)
    .then((response) => response.json().then((payload) => ({ ok: response.ok, payload })))
    .then(async ({ ok, payload }) => {
      if (!ok || !payload.orders || !payload.orders.length) return;
      orders = payload.orders;
      await show(orders[0]);
      index = 1;
      queueNext();
    })
    .catch(() => {});
})();
